import { EventProcessor, Hub, Integration } from "@sentry/types";
import { SentryHubProvider } from "./sentry-hub.provider";
export class AngularSentryIntegration implements Integration {
    static id = "ApexAngularJS";
    name = AngularSentryIntegration.id;

    constructor(private sentryLogHubProvider: SentryHubProvider,
        private sentryExceptionHandlerHubProvider: SentryHubProvider) {
    }

    getCurrentHub: () => Hub;
    addGlobalEventProcessor: (callback: EventProcessor) => void;
    setupOnce(addGlobalEventProcessor: (callback: EventProcessor) => void, getCurrentHub: () => Hub): void {
        this.addGlobalEventProcessor = addGlobalEventProcessor;
        this.sentryLogHubProvider.$get = () => {
            const hub = getCurrentHub && getCurrentHub();
            return hub && hub.getIntegration(AngularSentryIntegration) && hub;
        };
        this.sentryExceptionHandlerHubProvider.$get = () => {
            const hub = getCurrentHub && getCurrentHub();
            return hub && hub.getIntegration(AngularSentryIntegration) && hub;
        };
    }
}
